<template>
  <div class="flex flex-col">
    <div class="grid grid-cols-12 gap-4">
      <AppModal v-model="showAddOccupation" title="Add Occupation">
        <new-occupation />
      </AppModal>
    </div>

    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12">
        <div class="flex items-center gap-2 justify-end mb-4">
          <button
            @click="openForm"
            class="btn-primary"
          >
            <i class="fa-solid fa-plus"></i>
            <span>Add Occupation</span>
          </button>
        </div>

        <div v-if="spinner" class="w-full bg-gray-200 rounded-full h-1 overflow-hidden mb-4">
          <div class="bg-primary h-1 rounded-full animate-pulse" style="width: 100%"></div>
        </div>

        <div class="bg-white rounded border border-gray-200 overflow-hidden">
          <div class="overflow-x-auto">
            <table class="w-full text-xs">
              <thead class="bg-gray-50 sticky top-0">
                <tr>
                  <th class="text-left py-3 px-4 font-semibold text-gray-700 border-b border-gray-200 w-16">#</th>
                  <th class="text-left py-3 px-4 font-semibold text-gray-700 border-b border-gray-200">Name</th>
                  <th class="text-center py-3 px-4 font-semibold text-gray-700 border-b border-gray-200 w-32">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(occupation, idx) in occupations"
                  :key="occupation.id"
                  class="hover:bg-gray-50 transition"
                >
                  <td class="py-3 px-4 border-b border-gray-200">{{ idx + 1 }}</td>
                  <td class="py-3 px-4 border-b border-gray-200 capitalize font-medium">{{ occupation.name }}</td>
                  <td class="py-3 px-4 border-b border-gray-200">
                    <div class="flex items-center justify-center gap-2">
                      <button
                        class="btn-sm-primary"
                      >
                        <i class="fa-solid fa-pencil"></i>
                        <span>Edit</span>
                      </button>
                      <button
                        class="btn-sm-danger"
                      >
                        <i class="fa-solid fa-trash"></i>
                        <span>Delete</span>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr v-if="occupations.length === 0">
                  <td colspan="3" class="py-8 px-4 text-center text-gray-500">
                    No occupations found. Click "Add Occupation" to create one.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { useConfigurationsStore } from "../../../stores";
import AppModal from "@/components/ui/AppModal.vue";
import NewOccupation from "@/domains/home/services/configurations/views/settings/ocupations/NewOccupation.vue";

interface Occupation {
  id: string
  name: string
}

const store = useConfigurationsStore();
const showAddOccupation = ref(false)
const occupations = ref<Occupation[]>([])
const spinner = ref(false)

const openForm = () => {
  showAddOccupation.value = true
}

const fetchData = () => {
  spinner.value = true
  store.fetchOccupations();
}

onMounted(() => {
  fetchData()
})

watch(
  () => store.occupations,
  (data) => {
    if (data) {
      occupations.value = data
      spinner.value = false
    }
  }
)

watch(
  () => store.error,
  (error) => {
    if (error) {
      spinner.value = false
      // @ts-ignore - errorToast is injected globally
      window.errorToast('Error', 'Occupation creation failed')
    }
  }
)
</script>
